module.exports = __webpack_public_path__ + "static/home_background-2b6e9e3a589f257ef6389027a800123b.jpg";